import React, { Component } from 'react';
// import { Parallax } from 'react-skrollr'

import styles from  './styles.js';

class HvadEr extends Component {
	render() {

		let elmStyl = Object.assign({}, styles.container, {
		});

		return (
			<div style={elmStyl} className='kulturEvent'>
				<div style={styles.flex}>
					<div style={styles.textComponent}>
						<div style={styles.textComponentInner}>
							<h1>Byg Et Digt - en Kultur Event </h1>
							<div>
								<p>
								Litterær kreativ workshop for voksne, hvor glæden ved ordet, sproget og fortællingen sættes i fokus. Der skabes Poesi med ordene fra kasserede biblioteksbøger. Ordet viser vejen og du skal bare give slip og  følge med.
								</p>
								<p>
								Cut -Up poesi trækker historisk på Dadaisterne, som klippede  ord ud fra avisen eller bøger, hvorefter de sammensættes tilfældigt på ny.  Er i familie med Surrealisternes autoskrift.
								</p>
								
							</div>
						</div>
					</div>
				</div>
			</div>

		)
	}
}

export default HvadEr;





// WEBPACK FOOTER //
// ./src/components/HvadErKultur.js